import { ApiResponse } from "../utils/api/ApiProps";
import api from "../utils/api";
import { GetTableParams } from "./data-fetch-settings";
import { CreateUserRequest, UsersDetail } from "../types/settings/UsersTypes";
import { UsersApiData } from "../types/settings/settings";

export const getUsers = async ({
  page = 1,
  search_term = "",
  sort_column,
  sort_order,
  limit = 30
}: GetTableParams = {}): Promise<ApiResponse<UsersApiData>> => {
  const searchParams = new URLSearchParams();

  searchParams.append("page", page.toString());
  if (search_term) searchParams.append("search_term", search_term);
  if (sort_column) searchParams.append("sort_column", sort_column);
  if (sort_order) searchParams.append("sort_order", sort_order);
  if (limit) searchParams.append("limit", limit.toString());

  const queryString = searchParams.toString();
  const url = queryString ? `/users?${queryString}` : "/users";

  return await api.get<UsersApiData>(url);
};

// single user data
export const getUserData = async (
  uuid: string
): Promise<ApiResponse<{ data: UsersDetail }>> => {
  return await api.req<{ data: UsersDetail }>({
    url: `/users/${uuid}`,
    method: api.Method.GET,
  });
};

export const deleteUsers = async (uuid: string): Promise<ApiResponse> => {
  const response = await api.req({
    url: `/users/${uuid}`,
    method: api.Method.DELETE,
  });

  return response;
};

export const createUser = async (
  data: CreateUserRequest
): Promise<ApiResponse<{ data: UsersDetail }>> => {
  const response = await api.req<{ data: UsersDetail }>({
    url: "/users",
    method: api.Method.POST,
    body: data,
  });

  return response;
};

export const updateUser = async (
  uuid: string,
  data: CreateUserRequest
): Promise<ApiResponse<{ data: UsersDetail }>> => {
  const response = await api.req<{ data: UsersDetail }>({
    url: `/users/${uuid}`,
    method: api.Method.POST,
    body: data,
  });

  return response;
};
